module.exports = __webpack_public_path__ + "static/media/chain.5ec3af3f.jpg";